import request from '@/utils/request'
import uploadRequest from '@/utils/upload-request'

export function deleteImage(data) {
  return request.post('/elecnotes/delete', data)
}

export function uploadImages(data) {
  return uploadRequest.post('/elecnotes/upload', data)
}

export function getLastBatch(data) {
  return request.post('/elecnotes/last-batch', data)
}

export function getElecnotesDetail(data) {
  return request.post('/elecnotes/detail', data)
}

export function getElecnotesList(data) {
  return request.post('/elecnotes/list', data)
}



// WEBPACK FOOTER //
// ./src/api/elecnotes.js